import { put, call, takeEvery } from "redux-saga/effects"
import { getField } from "src/engine/repositories/resourceTypeFields"

import { READ } from "../actions/types"
import { readSuccess, readError } from "../actions/creators/read"

// read fields saga
function* requestRead(action) {
  const { config } = action
  try {
    const response = yield call(getField, config)
    yield put(readSuccess(action, response))
  } catch (error) {
    yield put(readError(action, error))
  }
}

export default function* readSaga() {
  yield takeEvery(READ, requestRead)
}
